module.exports = __webpack_public_path__ + "static/media/loading-image.dda53218.jpg";